export const environment = {
  production: false,
  ENV: 'dev',
  USING_MOCKS: false,
  BFF: {
    BASE_URL: 'https://dev.bff.apv.afpcapital.cl',
  },
  SECURITY_MODULE: {
    BASE_URL: 'https://fe-seguridad-dev.afpcapital.cl/remoteEntryClaveSeguridad.js',
  },
};
